import FileTypeIcon from './fileTypeIcon';

export default FileTypeIcon;